import { ForgotPasswordPage } from '@discovr/ui';
import { auth as authApi } from '@discovr/api';

export default function BrandForgotPasswordPage() {
  return (
    <ForgotPasswordPage
      appName="Discovr"
      onSendReset={(email) => authApi.requestPasswordReset(email)}
    />
  );
}
